import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-balloons',
	templateUrl: './icon-balloons.component.svg',
})
export class IconBalloonsComponent {}
